export default {"src":"/_next/static/media/plain.830b9d27.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};